import { render, staticRenderFns } from "./ContactUs.vue?vue&type=template&id=fbd0fc06&scoped=true&"
import script from "./ContactUs.vue?vue&type=script&lang=js&"
export * from "./ContactUs.vue?vue&type=script&lang=js&"
import style0 from "./ContactUs.vue?vue&type=style&index=0&id=fbd0fc06&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd0fc06",
  null
  
)

export default component.exports